import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import {
  APP_VERSION_NOTES_REGISTRY,
  VersionNotes,
  notesForVersion,
} from '../../version-notes';

export interface VersionNotesDialogData {
  /** Actuele productversie (package.json), bv. 1.0.3d. */
  currentVersion: string;
  /** Alle bekende release-notes, nieuwste eerst. */
  registry: VersionNotes[];
  buildRef: string;
}

@Component({
  selector: 'app-version-notes-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './version-notes-dialog.component.html',
  styleUrls: ['./version-notes-dialog.component.scss'],
})
export class VersionNotesDialogComponent {
  public readonly registry: VersionNotes[];
  public selected: VersionNotes;

  constructor(
    private dialogRef: DialogRef,
    @Inject(DIALOG_DATA) public data: VersionNotesDialogData,
  ) {
    this.registry =
      data.registry?.length > 0
        ? data.registry
        : APP_VERSION_NOTES_REGISTRY;
    this.selected = notesForVersion(data.currentVersion);
  }

  public select(notes: VersionNotes): void {
    this.selected = notes;
  }

  public isCurrent(notes: VersionNotes): boolean {
    return notes.version === this.data.currentVersion.replace(/^v/i, '');
  }

  public close(): void {
    this.dialogRef.close();
  }
}
